<template>
    <div>
        <Loading :loading="$apollo.queries.languageStat.loading" />
        <Navbar :showLangs="false" />
        <v-fade-transition>
            <v-container fluid v-show="!($apollo.queries.languageStat.loading)">
                <v-layout row wrap align-center justify-center>
                    <v-flex xs12 md8 lg4 >
                        <h1 class="text-xs-center mb-2 display-1 font-weight-light">
                            Total keys: {{ languageStat.totalKeys }}
                        </h1>
                        <v-container>
                            <v-layout
                                row
                                wrap
                                align-center
                                class="text-xs-center primary white--text pa-4"
                            >
                                <v-flex xs4>
                                    <h5 class="title font-weight-light">Language</h5>
                                </v-flex>
                                <v-flex xs4>
                                    <h5 class="title font-weight-light">Active</h5>
                                </v-flex>
                                <v-flex xs4>
                                    <h5 class="title font-weight-light">%</h5>
                                </v-flex>
                            </v-layout>
                            <v-layout
                                row
                                wrap
                                align-center
                                class="text-xs-center px-4 py-2"
                                v-for="{lang, active} in languageStat.langs"
                                :key="lang"
                            >
                                <v-flex xs4>
                                    <v-btn
                                        flat
                                        color="primary"
                                        :to="`/translations/${lang}`"
                                    >
                                        {{ lang }}
                                    </v-btn>
                                </v-flex>
                                <v-flex xs4>
                                    <h6 class="title">
                                        {{ active }}
                                    </h6>
                                </v-flex>
                                <v-flex xs4>
                                    <h6 class="title">
                                        {{ Math.round((languageStat.totalKeys - active) / languageStat.totalKeys * 100 * 100 ) / 100 }}
                                    </h6>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-fade-transition>
    </div>
</template>

<script>

import Navbar from "@/components/Navbar"
import Loading from "@/components/Loading"
import { LANGUAGE_STAT } from "../graphql"

export default {
    components: {
        Navbar,
        Loading
    },
    apollo: {
        languageStat: LANGUAGE_STAT
    },
    data () {
        return {
            languageStat: {
                totalKeys: 0,
                langs: []
            }
        }
    }
}

</script>
